import {
    NavLink, titleToUrl, useSelector,
} from "../../imports/generalImport";
import { Box, Container, Typography } from "../../imports/muiImport";
import { Swiper, SwiperSlide } from 'swiper/react';

function ProductCategory() {
    const category = useSelector((state) => state.Category.allData);
    const linkProps = (categoryTitle) => {
        return { pathname: '/card-list', search: `category=${titleToUrl(categoryTitle)}` };
    };

    return (
        <Container maxWidth="xl">
            <Box
                sx={{
                    p: 1,
                    mt: 6,
                    mb: 4,
                    backgroundColor: "borderColor.main2",
                    borderRadius: "20px",
                    mx: 0
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "white.main",
                        borderRadius: "20px",
                    }}
                >
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={2}
                        breakpoints={{
                            640: {
                                slidesPerView: 5,
                            },
                            768: {
                                slidesPerView: 5,
                            },
                            1024: {
                                slidesPerView: 11,
                            },
                            1500: {
                                slidesPerView: 13,
                            },
                        }}
                    >

                        {category?.map((item, index) => {
                            return (item?.products?.length >= 1 &&
                                <SwiperSlide key={`home-ProductCategory-${item?.title}`}>
                                    <NavLink
                                        to={linkProps(item?.title)}
                                        style={{
                                            textDecoration: "none",
                                            borderRadius: "20px",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <Box sx={{
                                            maxWidth: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: 100,
                                            textAlign: "center",
                                            py: 1,
                                            my: "4px",
                                            mx: 0,
                                            px: '4px',
                                            "&:hover": {
                                                backgroundColor: "borderColor.main2",
                                                // backgroundColor: "#dee5eb",
                                                // borderBottom: "1px solid rgba(33,36,39,.42)",
                                                boxShadow: 3,
                                                borderRadius: 4,
                                                "img": {
                                                    borderRadius: "50%",
                                                    boxShadow: 3,
                                                }
                                            }
                                        }}>
                                            <Box component="img"
                                                src={item?.image}
                                                loading="lazy"
                                                alt={`gift-category-${item?.title}`}
                                                sx={{
                                                    minWidth: 40,
                                                    minHeight: 40,
                                                    width: 40,
                                                    height: 40,
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <Typography variant="subtitle1" sx={{
                                                fontSize: 13,
                                                color: "#212427",
                                                fontWeight: 500,
                                                whiteSpace: "wrap",
                                                flex: 1,
                                                minHeight: 45,
                                                textDecoration: "none !important"
                                            }}>
                                                {item?.title}
                                            </Typography>
                                        </Box>
                                    </NavLink>
                                </SwiperSlide>
                            )
                        })}

                    </Swiper>
                </Box>

            </Box>
        </Container>
    );
}

export default ProductCategory